module.exports = __webpack_public_path__ + "res/glyphicons-halflings-regular.svg?89889688147bd7575d6327160d64e760";


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-sass/assets/fonts/bootstrap/glyphicons-halflings-regular.svg
// module id = 9
// module chunks = 0